// global.img_Url = "http://localhost:8000";
// global.back_url = "http://localhost:3000/login";

// global.img_Url = "http://dashboard.greatdoc.org/server/public";
// global.back_url = "http://dashboard.greatdoc.org/login";

{
  process.env.NODE_ENV === "development"
    ? (global.img_Url = process.env.REACT_APP_DEV_MODE_IMAGE_URL)
    : (global.img_Url = process.env.REACT_APP_PRO_MODE_IMAGE_URL);
}

{
  process.env.NODE_ENV === "development"
    ? (global.back_url = process.env.REACT_APP_DEV_MODE_BACK_URL)
    : (global.back_url = process.env.REACT_APP_PRO_MODE_BACK_URL);
}
